
























































import { Popover } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import CustomerNotification from '@/models/customer-notification'

import dayjs, { Dayjs } from '@/dayjs'
import EventBus from '@/event-bus'
import CustomerNotificationService from '@/services/notificationServices/CustomerNotificationService'

import ProcessedCustomerNotification from '../models/processed-customer-notification'

@Component({
  components: {
    [Popover.name]: Popover,
  },
})
export default class CustomerNotificationListItem extends Vue {
  @Prop() notification!: CustomerNotification
  @Prop() dismissable!: boolean
  @Prop({ default: false }) colored!: boolean
  @Prop({ default: false }) minimal!: boolean
  @Prop({ default: false }) withPopover!: boolean

  get processedNotification(): ProcessedCustomerNotification {
    return new CustomerNotificationService(this.notification).call()
  }

  get transformedNotification() {
    return {
      template: `
        <div> ${this.processedNotification.message} </div>
      `,
    }
  }

  get departure(): Dayjs {
    return dayjs.utc(this.notification.bookingInfo.departure)
  }

  dismissNotification() {
    EventBus.$emit('dismissNotification', this.notification.id)
  }
}
